











import { Component, Vue } from 'vue-property-decorator'
import VueMarkdown from 'vue-markdown'
import { ContentModel } from '@/models/Content.model'
import { contentWebservice } from '@/webservices/content.webservice'

@Component({
    components: {
        VueMarkdown,
    },
})
export default class AboutUs extends Vue {
    private content: ContentModel = {} as ContentModel

    async mounted() {
        this.content = await contentWebservice.getContent()
    }
}
